import { notEmpty } from '@festina-life/core'
import { useMemo } from 'react'

import { useHook } from '../lenteHooks'

type Service = 'life' | 'moneyIn' | 'moneyOut' | 'crm' | 'collCalc' | 'unitlink'

/**
 * Fetch the enum definition for the given type.
 *
 * Return all the literal names used in the enum variants as an array of options for use in a Select input.
 */
export const useEnumOptions = (name: string, service: Service = 'life') => {
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const { data } = useHook(`fetchers.${service}.useFetchEnumValues`)({
    tenantId,
    name,
  })

  return useMemo(
    () =>
      data?.literals?.map((literal) => literal?.name).filter(notEmpty) ?? [],
    [data?.literals],
  )
}
